import type McpChatPanel from "./mcp-chat-panel";

/**
 * Singleton reference to the McpChatPanel instance.
 * This allows the docked wrapper (rendered in left/right panels)
 * to access the shared chat state and methods from the floating panel
 * (rendered in the left menu).
 */
let mcpChatPanelInstance: McpChatPanel | null = null;

export function setMcpChatPanelInstance(instance: McpChatPanel | null): void {
  mcpChatPanelInstance = instance;
}

export function getMcpChatPanelInstance(): McpChatPanel | null {
  return mcpChatPanelInstance;
}

/** Custom event name dispatched when the user wants to undock the chat from a panel. */
export const MCP_CHAT_UNDOCK_EVENT = "mcp-chat-undock";

/** Dispatch an undock request that DesignLeftMenu listens for.
 *  When drag coordinates are provided the floating panel will start
 *  dragging immediately so the user can place it at any anchor. */
export function requestUndock(targetAnchor: string, dragStart?: { clientX: number; clientY: number }): void {
  window.dispatchEvent(
    new CustomEvent(MCP_CHAT_UNDOCK_EVENT, {
      detail: { anchor: targetAnchor, dragStart }
    })
  );
}
